import { ClassProvider } from '@angular/core';

import { Types } from '../../../domain/types.domain';
import { ValidateCpfEmailService } from '../../../domain/user/services/validate-cpf-email.service';

export class ValidateCpfEmailServiceInstruction implements ClassProvider {
  provide = Types.ValidateCpfEmailService;
  useClass = ValidateCpfEmailService;
}
